import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "advent-calender-form",
  class: "row"
}
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-lg-7 advent-form" }
const _hoisted_7 = ["error"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["error"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["error"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.zens.bike/datenschutz.php",
  target: "_blank"
}, "Datenschutzbestimmungen", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2" }, " Mit * markierten Felder sind Pflichtfelder. ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-h3 bold text-center" }, " Vielen Dank für Ihre Teilnahme ", -1)

import {
  reactive, ref,
} from 'vue';

import Expansion from '@/components/Expansion.vue';
import Checkbox from '@/components/Checkbox.vue';
import AdventAPI from '@/api/AdventAPI';
import BaseSpacer from '@/components/BaseSpacer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdventCalenderForm',
  props: {
  selectedDay: Object,
},
  setup(__props) {

const props = __props;

const formSentSuccessfully = ref(false);

const errors = reactive({ value: {} as Record<string, string | string[]> });



const form = reactive({
  name: null as string | null,
  email: null as string | null,
  phone: null as string | null,
  day: props.selectedDay?.day,
  privacy: null,
});

const sendForm = () => {
  AdventAPI.submit('email', {
    ...form,
  })
    .then(() => {
      formSentSuccessfully.value = true;
    })
    .catch((response) => {
      const responseErrors = response.errors;
      if (Object.keys(responseErrors).length) {
        errors.value = responseErrors;
      }
    });
};

const submit = () => {
  sendForm();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Expansion, {
      expanded: !formSentSuccessfully.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close', false))),
          class: "advent-form-close"
        }, "X"),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.selectedDay.headline), 1),
          _createElementVNode("p", {
            innerHTML: __props.selectedDay.price
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "col-12 col-lg-5 calender-img",
            style: _normalizeStyle({ backgroundImage: `url(${__props.selectedDay.img})` })
          }, null, 4),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "fs-small",
              type: "text",
              name: "name",
              placeholder: "Dein Name*",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.name) = $event)),
              error: errors.value.name,
              required: ""
            }, null, 8, _hoisted_7), [
              [_vModelText, form.name]
            ]),
            (errors.value.name)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "advent-error-message",
                  innerHTML: errors.value.name
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              name: "email",
              placeholder: "Deine E-Mail-Adresse*",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.email) = $event)),
              error: errors.value.privacy,
              required: ""
            }, null, 8, _hoisted_9), [
              [_vModelText, form.email]
            ]),
            (errors.value.email)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "advent-error-message",
                  innerHTML: errors.value.email
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "telefon",
              placeholder: "Deine Telefonnummer*",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.phone) = $event)),
              error: errors.value.privacy,
              required: ""
            }, null, 8, _hoisted_11), [
              [_vModelText, form.phone]
            ]),
            (errors.value.phone)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "advent-error-message",
                  innerHTML: errors.value.phone
                }, null, 8, _hoisted_12))
              : _createCommentVNode("", true),
            _createVNode(Checkbox, {
              name: "datenschutzen",
              modelValue: form.privacy,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.privacy) = $event)),
              error: errors.value.privacy,
              required: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Hiermit bestätige ich, dass ich die "),
                _hoisted_13,
                _createTextVNode(" gelesen habe und erkläre mich mit diesen einverstanden. ")
              ]),
              _: 1
            }, 8, ["modelValue", "error"]),
            _createElementVNode("button", {
              class: "fs-6 bold",
              onClick: submit
            }, " Teilnehmen und Adventsangebot sichern "),
            _hoisted_14
          ])
        ])
      ]),
      _: 1
    }, 8, ["expanded"]),
    _createVNode(Expansion, { expanded: formSentSuccessfully.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close', false))),
          class: "advent-form-close"
        }, "X"),
        _createVNode(BaseSpacer),
        _hoisted_15
      ]),
      _: 1
    }, 8, ["expanded"])
  ]))
}
}

})